// UserIcon.tsx
import { useRouteLoaderData } from "@remix-run/react";
import clsx from "clsx";
import type { FunctionComponent } from "react";
import type { loader as rootLoader } from "../../root";
import { generateFileURL } from "~/utils/file/generateFileURL";

interface UserIconProps {
  iconPath: string;
}

const UserIcon: FunctionComponent<
  UserIconProps
> = ({ iconPath }) => {
  const root =
    useRouteLoaderData<typeof rootLoader>("root");

  return (
    <div
      className={clsx(
        "aspect-square",
        "overflow-hidden",
        "rounded-full",
        "w-full",
        "border",
        "mx-auto",
        "border-black",
        "bg-gray-200",
      )}
    >
      {iconPath && (
        <img
          src={generateFileURL(
            iconPath,
            undefined,
            root?.basePath,
          )}
          className={clsx(
            "h-full w-full object-cover",
          )}
          alt=""
        />
      )}
    </div>
  );
};

export default UserIcon;
